<template>
  <div :class="{ index: isIndex }" v-if="onload">
    <Header v-show="$route.meta.show" />
    <router-view />
    <Footer v-show="$route.meta.show" />
    <Toolbar v-show="$route.meta.show" />
  </div>
</template>

<style>
body {
  color: #333;
  font-size: 14px;
  font-family: "Microsoft YaHei";
  line-height: 1;
  background-color: #fff;
}
</style>

<style lang="scss" scoped>
.index {
  background-color: #fafafa;
}
</style>

<script>
import Header from '@/components/Header';
import Footer from '@/components/Footer';
import Toolbar from '@/components/Toolbar';

export default {
  name: 'App',
  components: {
    Header,
    Footer,
    Toolbar,
  },
  data() {
    return {
      onload: false,
      isIndex: false,
      userInfo: {},
      isLoadChat: false,
    };
  },
  created() {
    // 用户信息
    this.$store.dispatch('app/getUserInfo').then((data) => {
      this.userInfo = data || {};

      // 栏目列表
      this.$store.dispatch('app/getColumns').then(() => {
        this.onload = true;
      });
    });
  },
  methods: {
    chat() {
      if (!this.isLoadChat) {
        this.isLoadChat = true;

        const {
          idStr, realName, mobilePhone, email,
        } = this.userInfo;
        const script = document.createElement('script');

        script.type = 'text/javascript';
        script.id = 'zhichiScript';
        script.src = `https://www.sobot.com/chat/frame/js/entrance.js?sysNum=779f1457e070453298e97fd9cb676886&partnerId=${idStr}&params={"realName":"${realName}","mobilePhone":"${mobilePhone}","email":"${email}"}`;
        script.setAttribute('class', 'zhiCustomBtn');
        script.setAttribute('data-args', 'true');

        const $body = document.body;
        $body.appendChild(script);

        script.onload = () => {
          /* global getzhiSDKInstance */
          const zhiManager = getzhiSDKInstance();
          zhiManager.on('load', () => {
            zhiManager.initBtnDOM();
            zhiManager.set('horizontal', 20);
            zhiManager.set('customBtn', 'true');
            zhiManager.set('powered', false);
            zhiManager.expand();
            const ZCChatFrame = document.getElementById('ZCChatFrame');
            ZCChatFrame.style.right = '65px';
          });
        };
      }
    },
    advice() {
      window.open(`${process.env.VUE_APP_PM}adviseout/entersadd.action?qfrom=116`);
    },
  },
  watch: {
    $route(to) {
      if (to.path === '/') {
        this.isIndex = true;
      } else {
        this.isIndex = false;
      }
    },
  },
};
</script>
